<template>
  <div>
    <v-toolbar class="primary">
      <v-icon dark>settings</v-icon>
      <v-toolbar-title class="white--text">Other Admin Settings</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-sm>
      <!-- Start Job Number -->
      <v-layout>
        <span class="title mr-3 mt-2"><v-icon class="mr-3">ballot</v-icon>Starting Job Number #{{currentYear}}</span>
          <v-text-field :disabled="projects" :placeholder='currentJobNumber' solo v-model="currentJobNumber"></v-text-field>
          <v-btn :disabled="projects" @click="changeJobNumber()" class='primary'>Save</v-btn>
          <span class="ml-3 mt-3">This setting can only be changed if there are currently NO projects created.</span>
      </v-layout>
      <v-layout mt-2 justify-center row wrap>
        <!-- Add information here -->
      </v-layout>
      <v-layout>
        <v-btn @click="notifyUsersOfUpdate" class="primary">Notify Users of Update</v-btn>
        <p v-if="notifyUsersOfUpdateSuccess"><strong>Notification Successfull!</strong></p>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { db } from '../../firebaseInit'

export default {
  data () {
    return {
      notifyUsersOfUpdateSuccess: false,
      currentYear: new Date().getFullYear().toString().substr(-2),
      currentJobNumber: 'Getting Current Job Number...'
    }
  },
  created () {
    this.getCurrentJobNumber()
  },
  computed: {
    projects () {
      let getProjects = this.$store.getters.projectSearch
      if (!getProjects || getProjects.length < 1) {
        return false
      } else {
        return true
      }
    },
    newJobNumber () {
      return parseInt(`${this.currentYear}${this.currentJobNumber}`)
    }
  },
  methods: {
    notifyUsersOfUpdate () {
      let allUsers = []
      db.collection('users').get().then(results => {
        results.forEach(doc => {
          allUsers.push(doc.data())
        })
      }).then(() => {
        allUsers.forEach(user => {
          db.collection('users').doc(user.id).update({ updateNotify: true })
        })
        this.notifyUsersOfUpdateSuccess = true
      })
    },
    getCurrentJobNumber () {
      db.collection('settings').doc('client_settings').get().then(settings => {
        this.currentJobNumber = settings.data().current_job_number.toString().substr(2, 3)
      })
    },
    changeJobNumber () {
      if (this.currentJobNumber.length > 3) {
        alert('Your entered job number can only be a maximum of 3 digits please try again!')
        this.getCurrentJobNumber()
      } else {
        if (this.currentJobNumber.length === 1) {
          this.currentJobNumber = '00' + this.currentJobNumber
        }
        if (this.currentJobNumber.length === 2) {
          this.currentJobNumber = '0' + this.currentJobNumber
        }
        db.collection('settings').doc('client_settings').update({current_job_number: this.newJobNumber})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/OtherSettings.vue